import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ElevatedRealEstateStrategy() {
  return <section data-section-id="222933" id="the-foundation-of-your-build" className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/industrial_electrical_site_grid.png)] grayscale opacity-40" />
        <div className="absolute inset-0 bg-background/90" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]" />
      </div>

      {}
      <div className="relative z-10 flex w-full max-w-7xl flex-col items-center px-4 text-center">
        <div className="mb-8 flex items-center gap-3">
          <div className="h-px w-12 bg-primary" />
          <span className="font-mono text-sm font-medium uppercase tracking-[0.2em] text-primary">
            Infrastructure Excellence
          </span>
          <div className="h-px w-12 bg-primary" />
        </div>

        <h1 className="font-sans text-5xl font-bold uppercase leading-[0.9] tracking-tighter text-foreground sm:text-7xl lg:text-[110px]">
          The Foundation <br /> of <span className="text-primary">Successful</span> Builds
        </h1>

        <p className="mt-8 max-w-2xl font-sans text-lg leading-relaxed text-muted-foreground sm:text-xl">
          Precision-engineered electrical infrastructure and site preparation for commercial and industrial projects.
        </p>

        <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:gap-6">
          <Button asChild size="lg" className="h-14 rounded-none bg-primary px-10 text-base font-bold uppercase tracking-widest text-primary-foreground shadow-none transition-all duration-300 hover:bg-primary/90">
            <Link to="/contact">Request Site Survey</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="h-14 rounded-none border-2 border-foreground bg-transparent px-10 text-base font-bold uppercase tracking-widest text-foreground shadow-none transition-all duration-300 hover:bg-foreground hover:text-background">
            <Link to="/services">Our Services</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 z-10 flex -translate-x-1/2 animate-bounce flex-col items-center gap-3 text-foreground">
        <span className="font-mono text-[10px] font-bold uppercase tracking-[0.3em] opacity-40">
          System_Scroll
        </span>
        <ChevronDown className="size-5 text-primary" />
      </div>
    </section>;
}